
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/now-ui-dashboard.scss?v1.4.0";
import "assets/css/demo.css";

import AdminLayout from "layouts/Admin.js";
import Login from 'layouts/Login';
import Register from 'layouts/Register';
import PasswordReset from 'layouts/PasswordReset';

import reducers from './reducers';

import ReactGA from 'react-ga';


const trackingId = "UA-168226120-1"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);


const store = createStore(reducers,applyMiddleware(thunk))
console.log(console.log(store.getState()))
const hist = createBrowserHistory();

hist.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        <Route path="/login" render={(props) => <Login {...props} />}/>
        <Route path="/signUp" render={(props) => <Register {...props} />}/>
        <Route path="/password_reset" render={(props) => <PasswordReset {...props} />}/>
        <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
        <Redirect to="/admin/dashboard" />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
